document.addEventListener("DOMContentLoaded", function() {
    // Function to process the product items
    function processProductItems() {
        const productItems = document.querySelectorAll('.boost-sd__filter-block .boost-sd__product-item');

        productItems.forEach(productItem => {
            // Find the product title within the current item
            const productTitleElement = productItem.querySelector('.boost-sd__product-title');

            if (productTitleElement && !productItem.querySelector('.boost-sd__product-color')) {
                // Get the text content from the element
                let productText = productTitleElement.textContent;

                // Split the text into title and color
                //let [title, color] = productText.split(' - ');
                // Split the text into title and color using regex
                const splitPattern = / -\s*|\s*-\s*/;
                let [title, color] = productText.split(splitPattern);

                // Capitalize the title and lowercase the color
                if (title && color) { // Ensure both title and color exist
                    title = title.trim(); // Remove any extra spaces
                    color = color.trim(); // Remove any extra spaces
                    title = title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
                    color = color.toLowerCase();

                    // Update the title element text
                    productTitleElement.textContent = title;
                    productTitleElement.style.textTransform = 'uppercase';

                    // Create a new div for the color
                    const colorDiv = document.createElement('div');
                    colorDiv.className = 'boost-sd__product-color';
                    colorDiv.textContent = color;

                    // Apply styles to the new color div
                    colorDiv.style.color = 'rgb(14, 14, 14)';
                    colorDiv.style.fontSize = '15px';
                    colorDiv.style.fontStyle = 'normal';
                    colorDiv.style.fontWeight = '400';
                    colorDiv.style.textTransform = 'capitalize';
                    colorDiv.style.fontFamily = 'Lato';
                    colorDiv.style.margin = '0 auto';

                    // Insert the new color div after the title
                    productTitleElement.parentNode.insertBefore(colorDiv, productTitleElement.nextSibling);
                }
            }
        });
    }

    // Start the processing for the initial load
    processProductItems();

    // Observe the container for changes (e.g., when pagination loads new products)
    const targetNode = document.querySelector('.boost-sd__filter-block');
    const observerOptions = {
        childList: true,
        subtree: true
    };

    const observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                processProductItems();
            }
        }
    });

    // Start observing
    if (targetNode) {
        observer.observe(targetNode, observerOptions);
    }
});
